var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34488 10.6938L1.90002 8.22291L2.61431 7.50145L4.34499 9.25082L8.38617 5.17035L9.10044 5.89179L6.4143 8.60414L7.94431 10.1507L11.9855 6.07019L12.6998 6.79164L7.94419 11.5936L5.69993 9.32548L4.34488 10.6938ZM5.81828 9.20597L7.94424 11.3545L12.4631 6.79162L12.4631 6.7916L7.94454 11.3542L5.8186 9.20565L5.81828 9.20597ZM4.34591 9.48955L4.34558 9.48922L8.38615 5.40937L8.38647 5.4097L4.34591 9.48955ZM4.34493 10.4547L4.34558 10.454L2.13763 8.22261L2.61459 7.74086L2.61426 7.74053L2.13665 8.22294L4.34493 10.4547Z",
    fill: "#564372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/TickIcon.ab9a7a5116823f97992afcc3c2c346b7.svg";
export { ForwardRef as ReactComponent };